export const getLocalStorage = (): Storage | null =>
    typeof globalThis.localStorage !== 'undefined'
        ? globalThis.localStorage
        : null;

export const getSessionStorage = (): Storage | null =>
    typeof globalThis.sessionStorage !== 'undefined'
        ? globalThis.sessionStorage
        : null;

export const getLocalStorageItem = (key: string): string | null =>
    getLocalStorage()?.getItem(key) ?? null;

export const setLocalStorageItem = (key: string, value: string): void => {
    getLocalStorage()?.setItem(key, value);
};

export const removeLocalStorageItem = (key: string): void => {
    getLocalStorage()?.removeItem(key);
};

export const getLocalStorageKeys = (): string[] => {
    const storage = getLocalStorage();

    if (!storage) {
        return [];
    }

    const keys: string[] = [];
    for (let index = 0; index < storage.length; index++) {
        const key = storage.key(index);
        if (key !== null) {
            keys.push(key);
        }
    }

    return keys;
};

export const getSessionStorageItem = (key: string): string | null =>
    getSessionStorage()?.getItem(key) ?? null;

export const setSessionStorageItem = (key: string, value: string): void => {
    getSessionStorage()?.setItem(key, value);
};

export const removeSessionStorageItem = (key: string): void => {
    getSessionStorage()?.removeItem(key);
};
